/* @ngInject */
const myRailway = () => {
  return {
    restrict: 'E',
    scope: {
      myRailway: '=',
      enableProgression: '=?',
    },
    template: require('./myRailway.html'),

    /* @ngInject */
    controller: (
      $scope
    ) => {

    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myRailway



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/railway/directives/display/myRailway.js